import { useRoleStore } from './store/roleStore';

/**
 * Converts a product ID to its user-friendly title
 * @param {string} productId - The ID of the product/role
 * @returns {string} - The title of the product/role or the original ID if not found
 */
export function productIdToTitle(productId) {
  if (!productId) return '';
  
  try {
    const roles = useRoleStore.getState()?.roles || [];
    
    // If roles haven't been loaded yet, just return the ID
    if (!Array.isArray(roles) || roles.length === 0) {
      console.debug(`Roles not loaded yet or empty, using ID: ${productId}`);
      return productId;
    }
    
    const role = roles.find(r => r.id === productId);
    return role ? (role.title || role.name || productId) : productId;
  } catch (error) {
    console.error(`Error in productIdToTitle for ${productId}:`, error);
    return productId; // Fallback to ID on error
  }
}